import { renderSlot as _renderSlot, withModifiers as _withModifiers, withKeys as _withKeys, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_flick = _resolveDirective("flick")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "backdrop",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('backdropClick')))
    }, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "modal-window sm:rounded-lg",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('backdropClick')), ["escape"]))
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 32)), [
        [_directive_flick, {
                    onFlick: () => _ctx.$emit('flicked'),
                    onDrag: (dragCompletePercentage) => _ctx.$emit('drag', dragCompletePercentage),
                    dragStop: (willClose) => _ctx.$emit('dragStop', willClose),
                }]
      ])
    ])
  ]))
}